//TODO: Coming soon. I don't want to confuse the screen by showing types that are not available yet.
//EXAMPLE: const historyTypes = ['Filled Job', 'Cancellation', 'Tardy', 'No Show', 'New Job'];
export const historyTypes = [
    'All',
    'Filled Job',
    'Cancellation',
    'New Sub Job',
    'New Trial Run',
    'Continue Trial Run',
    'Center Requested Time Change',
    'Worker Requested Time Change',
];

export function updateSelectedTypes(newTypes: string[], oldTypes: string[], setTypes: (types: string[]) => void) {
    const nonAllTypes = newTypes.filter((t) => t !== 'All');
    if (oldTypes.includes('All') && nonAllTypes.length > 0) {
        setTypes(nonAllTypes);
    } else if (!oldTypes.includes('All') && newTypes.includes('All')) {
        setTypes(['All']);
    } else {
        setTypes(newTypes);
    }
}
